export const getResourceDetailsResourceBillingDataFixedCacheKey = (
  processKey: string,
) =>
  `${processKey}-resource-details-postUsersMeOrganisationsCurrentResourceExplorer-fixed-cache-key`;

export const getResourceDetailsResourceBillingGranularDataFixedCacheKey = (
  processKey: string,
) =>
  `${processKey}-resource-details-postUsersMeOrganisationsCurrentResourceExplorerGranularCosts-fixed-cache-key`;
